module.exports = __webpack_public_path__ + "static/img/ccod4.56463be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ccod4.png
// module id = SSR5
// module chunks = 0